module.exports = __webpack_public_path__ + "img/icon_video.0f9d1077.svg";